import { Button } from "common/components/ui/Button";
import { DialogFooter, DialogHeader } from "common/components/ui/Dialog";
import { DrawerFooter, DrawerHeader } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { LinkedInProfile } from "common/types";

import useIncludedListLeadsMutations from "../../../../datahooks/useIncludedListLeadsMutations";
import { startListLeadsBulkAction } from "../../../../utils";

interface BlacklistLeadsProps {
  listId: string;
  selectedLeads: LinkedInProfile[];
  onBack?: () => void;
  onClose: (shouldClearSelection: boolean) => void;
}

export default function BlacklistLeads({
  listId,
  selectedLeads,
  onBack,
  onClose,
}: BlacklistLeadsProps) {
  const isDesktop = useTwBreakpoint("lg");

  const Header = isDesktop ? DialogHeader : DrawerHeader;
  const Footer = isDesktop ? DialogFooter : DrawerFooter;

  const { removeListLead } = useIncludedListLeadsMutations(listId);

  function blacklistLeads() {
    startListLeadsBulkAction(
      ({ urn }, abortSignal) =>
        removeListLead({
          urn,
          shouldBlacklist: true,
          abortSignal,
        }),
      selectedLeads,
      (finishedItemsCount) =>
        finishedItemsCount === selectedLeads.length
          ? "Leads blacklisted"
          : `Blacklisting ${finishedItemsCount}/${selectedLeads.length} leads`,
    );
    onClose(true);
  }

  return (
    <>
      <Header
        title="Blacklist from workspace?"
        subtitle="Once blacklisted, they're blocked across your entire workspace. To include them again, remove them from the blacklist and the excluded tab of this list"
        onBack={onBack}
      />

      <Footer className="justify-end">
        <Button variant="secondary-black" onClick={() => onClose(false)}>
          Cancel
        </Button>
        <Button
          variant="outline-danger"
          disabled={!selectedLeads.length}
          onClick={blacklistLeads}
        >
          Blacklist
        </Button>
      </Footer>
    </>
  );
}
